/* global $, data, query_string */
// eslint-disable-next-line import/no-relative-packages
import '../bower_components/tablesorter/jquery.tablesorter.min'
import * as d3 from 'd3'

$('#d_oaa_table').tablesorter({
    sortInitialOrder: 'desc',
})

$('#btnUpdate').click(() => {
    window.location = `/directional_outs_above_average?year=${$(
        '#ddlSeason'
    ).val()}&min=${$('#ddlMin').val()}&team=${$('#ddlTeamId').val()}`
    return false
})
$('#btnCSV').click(() => {
    window.location = `/directional_outs_above_average?year=${$(
        '#ddlSeason'
    ).val()}&min=${$('#ddlMin').val()}&team=${$('#ddlTeamId').val()}&csv=true`
    return false
})

createLegend()

for (let x = 0; x < data.length; x++) {
    loadChart(data[x], `player_${data[x].player_id}`, 100, false)
}

function loadChart(data, id, size, showTitle) {
    let showRect = false
    if (id === 'chartLoad') {
        showRect = true
    }
    const opts = {
        div_id: id,
        width: size,
        showRect,
        name: data.name_display_last_first,
        data: [
            {
                oaa: Number(data.n_oaa_slice_back_left),
            },
            {
                oaa: Number(data.n_oaa_slice_in_left),
            },
            {
                oaa: Number(data.n_oaa_slice_in),
            },
            {
                oaa: Number(data.n_oaa_slice_in_right),
            },
            {
                oaa: Number(data.n_oaa_slice_back_right),
            },
            {
                oaa: Number(data.n_oaa_slice_back),
            },
        ],
        showFrequency: true,
        showTitle,
        showNumbers: true,
    }
    RouteEfficiencyByAngle(opts)
}

function createLegend() {
    const opts = {
        div_id: 'chart_legend',
        width: 250,
        data: [
            {
                oaa: 0,
            },
            {
                oaa: 0,
            },
            {
                oaa: 0,
            },
            {
                oaa: 0,
            },
            {
                oaa: 0,
            },
            {
                oaa: 0,
            },
        ],
        showFrequency: true,
        showTitle: false,
        showLegend: true,
    }
    RouteEfficiencyByAngle(opts)
}

function RouteEfficiencyByAngle(opts) {
    const screenWidth = opts.width

    const margin = { left: 0, top: 0, right: 0, bottom: 0 }
    const width = Math.min(screenWidth, 250) - margin.left - margin.right
    const height = Math.min(screenWidth, 250) - margin.top - margin.bottom
    const radius = Math.min(width, height) / 5
    const innerRadius = 0.15 * radius

    let svg = d3
        .select(`#${opts.div_id}`)
        .append('svg')
        .attr('id', `svg_${opts.div_id}`)
        .attr('width', width + margin.left + margin.right)
        .attr('height', height + margin.top + margin.bottom)

    if (opts.showRect) {
        svg.append('rect')
            .attr('width', '100%')
            .attr('height', '100%')
            .attr('fill', '#fff')
    }
    svg = svg
        .append('g')
        .attr('class', 'wrapper')
        .attr(
            'transform',
            `translate(${width / 2 + margin.left},${height / 2 + margin.top})`
        )

    /// ///////////////////////////////////////////////////////////
    /// ////////////////// Data &  Scales /////////////////////////
    /// ///////////////////////////////////////////////////////////

    const data = opts.data.reverse()

    // Create a color scale
    const blueGrayRed = ['#0071c0', '#f3f3f3', '#f31912']
    let RE_MIN = -12
    let RE_MAX = 12
    let RE_MID = 0.5 * (RE_MIN + RE_MAX)
    let colorScale = d3
        .scaleLinear()
        .domain([RE_MIN, RE_MID, RE_MAX])
        .range(blueGrayRed)
    let sliceSize = 7

    if (query_string.year === 'ALL') {
        RE_MIN = -30
        RE_MAX = 30
        RE_MID = 0.5 * (RE_MIN + RE_MAX)
        colorScale = d3
            .scaleLinear()
            .domain([RE_MIN, RE_MID, RE_MAX])
            .range(blueGrayRed)
        sliceSize = 13
    }

    // Create font scale
    const fontSizePie = d3.scaleLinear().domain([0, 500]).range([8, 10])
    const fontSizeTitle = d3.scaleLinear().domain([0, 500]).range([8, 20])

    const arc = d3
        .arc()
        .outerRadius(radius)
        .innerRadius((d) => {
            if (opts.showFrequency) {
                return (
                    (radius - innerRadius) *
                        ((d.data.oaa + sliceSize) / sliceSize) +
                    innerRadius
                )
            }
            return radius
        })

    const arcOuter = d3
        .arc()
        .innerRadius(innerRadius)
        .outerRadius((d) => {
            if (opts.showFrequency) {
                const test = d.data.oaa + sliceSize
                return (radius - innerRadius) * (test / sliceSize) + innerRadius
            }
            return radius
        })

    // Turn the pie chart 90 degrees counter clockwise, so it starts at the left
    const pie = d3
        .pie()
        .startAngle((330 * Math.PI) / 180)
        .endAngle((330 * Math.PI) / 180 + 2 * Math.PI)
        .value(() => 1)
        .padAngle(0.01)
        .sort(null)

    /// ///////////////////////////////////////////////////////////
    /// ///////////////// Create Donut Chart //////////////////////
    /// ///////////////////////////////////////////////////////////

    // Create the donut slices and also the invisible arcs for the text
    svg.selectAll('.donutArcs')
        .data(pie(data))
        .enter()
        .append('path')
        .attr('class', 'donutArcs')
        .attr('d', arc)
        .style('fill', (d) => colorScale(d.data.oaa))
        .style('stroke', '#000')
        .style('stroke-width', 1)

    const leagueAvgData = [
        {
            oaa: 0,
            text: 'Back',
        },
        {
            oaa: 0,
            text: 'Back Right',
        },
        {
            oaa: 0,
            text: 'In Right',
        },
        {
            oaa: 0,
            text: 'In',
        },
        {
            oaa: 0,
            text: 'In Left',
        },
        {
            oaa: 0,
            text: 'Back Left',
        },
    ]

    svg.selectAll('.la')
        .data(pie(leagueAvgData))
        .enter()
        .append('path')
        .attr('class', 'donutArcs')
        .attr('d', arcOuter)
        .style('fill', 'none')
        .style('stroke', '#c2c2c2')
        .style('stroke-width', 1.3)

    if (opts.showLegend) {
        svg.selectAll('.donutLabels')
            .data(pie(leagueAvgData))
            .enter()
            .append('text')
            .attr('class', 'donutText')
            .attr('dy', '.35em')
            .attr('text-anchor', 'middle')
            .attr('fill', '#000000')
            .style('font-size', '13px')
            .style('color', '#111111')
            .text((d) => d.data.text)
            .attr('transform', (d) => {
                // set the label's origin to the center of the arc
                const tempObj = d
                tempObj.innerRadius = innerRadius / 5 // Set Inner Coordinate
                tempObj.data.oaa = 10
                return `translate(${arc.centroid(tempObj)})`
            })
    }

    // Append the label names on the outside
    if (!opts.showLegend && opts.showNumbers) {
        svg.selectAll('.donutLabels')
            .data(pie(data))
            .enter()
            .append('text')
            .attr('class', 'donutText')
            .attr('dy', '.35em')
            .attr('text-anchor', 'middle')
            .attr('fill', '#000000')
            .style('font-size', fontSizePie(width))
            .style('color', '#111111')
            .text((d) => d.data.oaa)
            .attr('transform', (d) => {
                // set the label's origin to the center of the arc
                const tempObj = d
                tempObj.innerRadius = innerRadius / 5 // Set Inner Coordinate
                if (tempObj.data.oaa >= 0) {
                    tempObj.data.oaa = -4
                } else if (tempObj.data.oaa < 0) {
                    tempObj.data.oaa = 8
                }

                return `translate(${arc.centroid(tempObj)})`
            })
    }

    // Append the label names on the outside
    /* svg.selectAll(".donutLabels")
        .data(pie(data))
        .enter().append("text")
        .attr("class", "donutText")
        .attr("dy", ".35em")
        .attr("text-anchor", "middle")
        .style("font-size", fontSizePie(width))
        .style("color", "#111111")
        .attr("transform", function(d) { //set the label's origin to the center of the arc
        d.innerRadius = innerRadius/5; // Set Inner Coordinate
        var tempObj = JSON.parse(JSON.stringify(d));
        if (tempObj.data.oaa < 3) {
          tempObj.data.oaa = 8;
        }
        return "translate(" + arc.centroid(tempObj) + ")";

            /*d.innerRadius = innerRadius/2; // Set Inner Coordinate
            return "translate(" + arc.centroid(d) + ")";
        })
        .text(function (d) {
            return d.data.oaa;
        }); */

    /* svg.append("svg:text")
        .attr("dy", ".35em")
        .attr("text-anchor", "middle") // text-align: right
        .text("SP")
        .style("font-size", fontSizeTitle(width)); */

    if (opts.showTitle) {
        svg.append('text')
            .attr('y', -(height / 1.2))
            .attr('text-anchor', 'middle') // text-align: right
            .text(opts.name)
            .style('font-size', fontSizeTitle(width))
    }
}
$(document).ready(() => {
    $('#ddlTeamId').change(() => {
        $('#lblTeamId').html($('#ddlTeamId option:selected').text())
    })

    $('#ddlSeason').change(() => {
        $('#lblSeason').html($('#ddlSeason').val())
    })

    $('#ddlMin').change(() => {
        // $('#lblMin').html($('#Min').val());
        $('#lblMin').html(`Minimum Opportunities (${$('#ddlMin').val()})`)
    })

    if (query_string.min) {
        $('#ddlMin').val(query_string.min).attr('selected', true)
        $('#lblMin').html(`Minimum Opportunities (${$('#ddlMin').val()})`)
    }

    if (query_string.year) {
        $('#ddlSeason').val(query_string.year).attr('selected', true)
        $('#lblSeason').html($('#ddlSeason option:selected').text())
    }

    if (query_string.team) {
        $('#ddlTeamId').val(query_string.team).attr('selected', true)
        $('#lblTeamId').html($('#ddlTeamId option:selected').text())
    }
})
